import { render, staticRenderFns } from "./trainingModulePageStart2.vue?vue&type=template&id=18fe50fa&scoped=true&"
import script from "./trainingModulePageStart2.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageStart2.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageStart2.vue?vue&type=style&index=0&id=18fe50fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe50fa",
  null
  
)

export default component.exports